import { render, staticRenderFns } from "./GiftModalItem.vue?vue&type=template&id=73ff8d62&scoped=true&"
import script from "./GiftModalItem.vue?vue&type=script&lang=js&"
export * from "./GiftModalItem.vue?vue&type=script&lang=js&"
import style0 from "./GiftModalItem.vue?vue&type=style&index=0&id=73ff8d62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ff8d62",
  null
  
)

export default component.exports